export const RESPONSE_ERROR_SNACK_OPEN = 'error';
export const RESPONSE_ERROR_SNACK_CLOSE = 'RESPONSE_ERROR_SNACK_CLOSE';
export const RESPONSE_ERROR_POPUP = 'RESPONSE_ERROR_POPUP';